var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_83_1",
    "data-name": "Component 83 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3807",
    "data-name": "Rectangle 3807",
    fill: "#fff",
    stroke: "#c7c7c7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 3.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "sort-down-alt",
    transform: "translate(5.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14348",
    "data-name": "Group 14348",
    transform: "translate(1.498 9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13437",
    "data-name": "Path 13437",
    d: "M4.809,9.545a.552.552,0,0,0-1.1,0v9.591L2.441,17.886a.557.557,0,0,0-.781,0,.542.542,0,0,0,0,.772l2.207,2.181.008.008a.553.553,0,0,0,.772-.007l2.207-2.182a.541.541,0,0,0,0-.772.557.557,0,0,0-.781,0L4.809,19.137Zm4.414.545A.545.545,0,1,1,9.223,9h1.1a.545.545,0,1,1,0,1.091Zm0,3.272a.545.545,0,1,1,0-1.091h3.31a.545.545,0,1,1,0,1.091Zm0,3.272a.545.545,0,1,1,0-1.091H14.74a.545.545,0,1,1,0,1.091Zm-.552,2.727a.549.549,0,0,0,.552.545h7.724a.545.545,0,1,0,0-1.091H9.223A.549.549,0,0,0,8.671,19.363Z",
    transform: "translate(-1.498 -9)",
    fill: "#707070"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sortIcon.95793a69e36c97a0cc286c352f976e35.svg";
export { ForwardRef as ReactComponent };